import { regExp } from '@sigma-frontend-libs/commons'

import { proxy, services } from '@/utils'

import { getChannelTypes } from '@/components/services/otp-settings/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean,
    disabled: Boolean
  },

  computed: {
    validation() {
      return regExp.titleOtpSettingsSoft.test(this.proxy.name)
      && !!this.proxy.channelType
      && !!this.proxy.additionalSettings.senderId
      && !!this.proxy.additionalSettings.template
    },

    channelTypes() {
      return getChannelTypes(services['otp-settings/templates']).map(value => {
        return {
          title: this.getTranslate(`sendings.types.${value}`),
          value
        }
      })
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },
    'proxy.channelType'() {
      this.proxy.additionalSettings.senderId = undefined
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}

